import { Pipe, PipeTransform } from '@angular/core';

const schema = {
  'in progress': 'orange',
  'hold': 'powder-pink',
  'client payment': 'cyan',
  'in payment plan': 'blue',
  'broken arrangement': 'pink',
  'legal': 'yellow',
  'awaiting client': 'red',
  'in dispute': 'red',
  'cancelled': 'gray',
  'completed': 'green',
};

@Pipe({
  name: 'statusColor',
})
export class StatusColorPipe implements PipeTransform {
  transform(value: string): string {
    return schema[value] || '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/status-color.pipe.ts